// extracted by mini-css-extract-plugin
export default {"box":"index-module__box___Kng5C","show":"index-module__show___ANB_h","loading":"index-module__loading___ST0e9","spin":"index-module__spin___k8pOK"};